import { ObfuscateProvider } from "../Space/Space2";
import { useContext, useMemo } from "react";
import { HeaderNavLink } from "../../Components/Header/HeaderV2";
import { agendaRoute, useSpaceRoutesAccess } from "../Space/SpaceHelper";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/pro-duotone-svg-icons";
import { useCurrentAccount } from "../../Contexts/UserContext";
import RestrictedPeopleIdOnly from "./AgendaPeopleHelper";
import { useSpace } from "../../Contexts/SpaceContext";

const AgendaButton = ({
  className,
  labelText,
  vertical,
  buttonClass,
  disableCount,
  size,
  activeClassName
}) => {
  const ObfuscateState = useContext(ObfuscateProvider);
  const space = useSpace();
  const accessDict = useSpaceRoutesAccess();
  const user = useCurrentAccount();
  const asAccess = useMemo(() => {
    return (
      accessDict[agendaRoute.path] &&
      (space.Id === 1 || space.Id === 3 || space.Id === 469)
    );
  }, [accessDict, space.Id]);

  if (!asAccess) return null;

  // const accountSpace = useCurrentAccountSpace();

  // if(!(accountSpace.Space === 1 ||accountSpace.Space === 3)) return null

  return (
    <HeaderNavLink
      activeClassName={activeClassName}
      routeModule={agendaRoute}
      className={classNames("ar-header-rounded-icon", className || "ml-1")}
    >
      <div
        style={{
          opacity: ObfuscateState && 0.3,
          pointerEvents: ObfuscateState && "none"
        }}
        className={className}
      >
        <div
          className={classNames(
            `mr-0 ar-header-rounded-icon position-relative InboxButton position-relative cursor-pointer d-flex align-items-center`,
            buttonClass
          )}
        >
          <FontAwesomeIcon icon={faCalendar} size={size ? size : "lg"} />
          {labelText && (
            <span
              style={{ fontWeight: 500, textDecoration: "none" }}
              className="ml-12"
            >
              {labelText}
            </span>
          )}
        </div>
      </div>
    </HeaderNavLink>
  );
};

export default AgendaButton;
